const MIN_PASSWORD_LENGTH = 8;

// This mirrors password policy in User model on the backend
// Be sure to update both.
function isValidPassword(password) {
  return !!(password.length >= MIN_PASSWORD_LENGTH);
}

module.exports = isValidPassword;



// WEBPACK FOOTER //
// ./javascripts/components/shared/password_policy.js